import React, { useEffect, useRef } from 'react';
import Barcode from 'react-barcode';
import StatusIndicator from './StatusIndicator';
import { digitsOnly, validateUPC12 } from '../utils/barcodeUtils';
import { formatMetricSuffixFromPounds, formatWeightForDisplay } from '../utils/weightString';
import { resolveCardStatus } from '../utils/pidStatus';
import {
  Overlay,
  Panel,
  Header,
  Title,
  CloseButton,
  DetailGrid,
  InfoRow,
  InfoLabel,
  InfoValue,
  BarcodeWrapper,
} from '../styles/PackageIndexStyles';
import { X } from 'lucide-react';

const UPCDetailPanel = ({ group, onClose }) => {
  const panelRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const name = `${group.Retailer || ''} ${formatWeightForDisplay(group.Weight)}`.trim();
  const upcDigits = digitsOnly(group.UPC || '');
  const isValid = upcDigits.length === 12 && validateUPC12(upcDigits);

  return (
    <Overlay>
      <Panel ref={panelRef}>
        <Header>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', minWidth: 0 }}>
            <Title>{name}</Title>
            <StatusIndicator status={resolveCardStatus(group)} />
          </div>
          <CloseButton onClick={onClose}><X size={20} /></CloseButton>
        </Header>

        <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem 0' }}>
          {isValid ? (
            <BarcodeWrapper>
              <Barcode
                value={upcDigits}
                format={'UPC'}
                height={80}
                width={2}
                displayValue
                background="transparent"
                font="OCRB"
              />
            </BarcodeWrapper>
          ) : (
            <div>No UPC</div>
          )}
        </div>

        <DetailGrid>
          <InfoRow>
            <InfoLabel>Commodity</InfoLabel>
            <InfoValue>{group.Commodity}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Retailer</InfoLabel>
            <InfoValue>{group.Retailer}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Count / Weight</InfoLabel>
            <InfoValue>
              {formatWeightForDisplay(group.Weight)}
              {formatMetricSuffixFromPounds(group.Weight) ? (
                <span style={{ color: 'var(--shadow-a45)', fontWeight: 700 }}>
                  {formatMetricSuffixFromPounds(group.Weight)}
                </span>
              ) : null}
            </InfoValue>
          </InfoRow>
        </DetailGrid>
      </Panel>
    </Overlay>
  );
};

export default UPCDetailPanel;


